import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HighchartsChartModule } from 'highcharts-angular';

/* Modules */
import { MaterialModule } from '@modules/material/material.module';
import { IconsModule } from '@modules/material/icons/icons.module';

/* Pipes */
import { AmountPipe } from '@shared/pipes/amount.pipe';
import { ConvertUnitsPipe } from '@shared/pipes/convert-units.pipe';
import { DateRangePipe } from '@shared/pipes/date-range.pipe';
import { MinutesPipe } from '@shared/pipes/minutes.pipe';
import { SplitStringPipe } from '@shared/pipes/split-string.pipe';

/* Directives */
import { DragDropDirective } from '@shared/directives/drag-drop.directive';

/* Components */
import { AutocompleteInputFieldComponent } from '@shared/components/autocomplete-input-field/autocomplete-input-field.component';
import { ButtonGroupComponent } from '@shared/components/button-group/button-group.component';
import { CheckboxFieldComponent } from '@shared/components/checkbox-field/checkbox-field.component';
import { FileUploadComponent } from '@shared/components/file-upload/file-upload.component';
import { ImageModalComponent } from '@shared/components/image-modal/image-modal.component';
import { InputFieldComponent } from '@shared/components/input-field/input-field.component';
import { ProgressBarComponent } from '@shared/components/progress-bar/progress-bar.component';
import { SelectFieldComponent } from '@shared/components/select-field/select-field.component';
import { UtilizationInfoComponent } from '@shared/components/utilization-info/utilization-info.component';

@NgModule({
	declarations: [
		AmountPipe,
		AutocompleteInputFieldComponent,
		ButtonGroupComponent,
		CheckboxFieldComponent,
		ConvertUnitsPipe,
		DateRangePipe,
		DragDropDirective,
		FileUploadComponent,
		ImageModalComponent,
		InputFieldComponent,
		MinutesPipe,
		ProgressBarComponent,
		SelectFieldComponent,
		SplitStringPipe,
		UtilizationInfoComponent,
	],
	imports: [CommonModule, MaterialModule, IconsModule, FormsModule, ReactiveFormsModule, HighchartsChartModule],
	exports: [
		AmountPipe,
		AutocompleteInputFieldComponent,
		ButtonGroupComponent,
		CheckboxFieldComponent,
		ConvertUnitsPipe,
		DateRangePipe,
		DragDropDirective,
		FileUploadComponent,
		InputFieldComponent,
		MinutesPipe,
		ProgressBarComponent,
		SelectFieldComponent,
		SplitStringPipe,
		UtilizationInfoComponent,
	],
})
export class SharedModule {}
